import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		minWidth: 480,
	},
	intro: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.5,
	},
	targetList: {
		background: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.sm,
		maxHeight: 160,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	targetLine: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'baseline',
	},
	targetName: {
		fontWeight: typography.fontWeights.semibold,
	},
	targetId: {
		fontFamily: 'monospace',
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	searchResults: {
		border: common.border,
		borderRadius: common.borderRadius,
		maxHeight: 240,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
	},
	// Overrides for the `link` Button variant rendered as a clickable result row.
	resultRow: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		gap: spacing.xs,
		padding: spacing.sm,
		borderBottom: `1px solid ${colors.border.light}`,
		textAlign: 'left',
		fontSize: typography.fontSizes.sm,
		color: colors.text.main,
		width: '100%',
		minHeight: 'auto',
		borderRadius: 0,
		':hover': {
			background: colors.hover.light,
			textDecoration: 'none',
		},
	},
	resultRowSelected: {
		background: colors.hover.light,
	},
	resultName: {
		color: colors.text.main,
		fontWeight: typography.fontWeights.semibold,
	},
	resultMeta: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	errorBanner: {
		color: colors.danger.dark,
		background: colors.danger.light,
		padding: spacing.sm,
		borderRadius: common.borderRadius,
		fontSize: typography.fontSizes.sm,
	},
	// Composes with `errorBanner` at the call site to add inline action layout —
	// keeps the banner's colors/padding/font in a single source.
	errorBannerActionsRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
	},
	emptyResults: {
		padding: spacing.md,
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		textAlign: 'center',
	},
});
